import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleProgressAnalysisMD = {
  namespaced: true,

  state: {
    name: "progress-analysis",
    progressanalysis: [],
  },

  mutations,
  getters,
  actions,
};

export default moduleProgressAnalysisMD;
